import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GoogleSignIn from '../components/GoogleSignIn';
import SEOHelmet from '../components/SEOHelmet';
import { generateOrganizationSchema, generateSiteSearchSchema } from '../utils/seo';
import '../styles/Home.css';

const Home = () => {
  const { user } = useAuth();
  
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      generateOrganizationSchema(),
      generateSiteSearchSchema()
    ]
  };

  return (
    <div className="home">
      <SEOHelmet 
        title="MD Sweets Caterers - Traditional Indian Sweets Online | Fresh Delivery"
        description="Order authentic Indian sweets online from MD Sweets Caterers. Fresh Gulab Jamun, Rasgulla, Jalebi, Barfi, Ladoo & more. Custom catering for events. Fast delivery across India."
        keywords="indian sweets online, traditional sweets, gulab jamun, rasgulla, jalebi, barfi, ladoo, kaju katli, sweet shop, catering services, custom orders, wedding sweets"
        structuredData={structuredData}
      />
      <section className="hero">
        <div className="hero-content">
          <h1>Welcome to MD Sweets Caterers</h1>
          <p>Delicious traditional sweets made with love</p>
          <div className="hero-actions">
            <Link to="/shop" className="btn-hero">Shop Now</Link>
            <Link to="/custom-order" className="btn-hero btn-hero-secondary">Custom Orders</Link>
            {!user && (
              <div className="hero-auth">
                <GoogleSignIn 
                  className="btn-hero-google" 
                  text="Sign in with Google" 
                />
              </div>
            )}
          </div>
        </div>
      </section>
      
      <section className="custom-order-cta">
        <div className="cta-content">
          <h2>Planning a Special Event?</h2>
          <p>Let us create a custom menu for your wedding, birthday, corporate event, or any special occasion. We cater to events of all sizes with personalized service.</p>
          <div className="cta-features">
            <div className="cta-feature">
              <span className="cta-icon">🎉</span>
              <span>Custom Menus</span>
            </div>
            <div className="cta-feature">
              <span className="cta-icon">👥</span>
              <span>Any Group Size</span>
            </div>
            <div className="cta-feature">
              <span className="cta-icon">📅</span>
              <span>Flexible Scheduling</span>
            </div>
            <div className="cta-feature">
              <span className="cta-icon">💰</span>
              <span>Competitive Pricing</span>
            </div>
          </div>
          <Link to="/custom-order" className="btn-cta">Request Custom Order</Link>
        </div>
      </section>
      

      <section className="features">
        <div className="feature">
          <h3>🍬 Fresh & Quality</h3>
          <p>Made daily with premium ingredients</p>
        </div>
        <div className="feature">
          <h3>🚚 Fast Delivery</h3>
          <p>Quick delivery to your doorstep</p>
        </div>
        <div className="feature">
          <h3>💳 Secure Payment</h3>
          <p>Safe and secure online payments</p>
        </div>
      </section>
    </div>
  );
};

export default Home;
